import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { NewComerPromotionService } from "./new-comer-promotion.service";

@Component({
  selector: "host-new-comer-promotion",
  templateUrl: "./new-comer-promotion.component.html",
  styleUrls: ["./new-comer-promotion.component.scss"],
})
export class NewComerPromotionComponent implements OnInit {
  constructor(private srv: NewComerPromotionService, private http: HttpClient, private msg: NzMessageService) {}

  ngOnInit() {}

  onCancel() {
    this.srv.hidePromotion();
  }
  onReceive() {
    this.requestReceivePromotion();
    this.srv.hidePromotion();
  }

  private requestReceivePromotion() {
    this.http.post("/api/member_promotion/newcomer", null).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success("已领取，可在支付时使用");
      }
    });
  }
}
